<template>
  <div>
    <LoginPopup
      v-if="loginPopupState"
      :close-login-popup="closeLoginPopupProc"
    />
    <RouterView key="mainLayout" name="mainLayout" />
    <RouterView key="conferenceLayout" name="conferenceLayout" />
    <RouterView key="wavveonLayout" name="wavveon" />
    <RouterView key="member" name="member" />
    <RouterView key="adult" name="adult" />
    <RouterView key="voucher_popup" name="voucher_popup" />
    <RouterView key="callback" name="callback" />
    <RouterView key="construction" name="construction" />
    <RouterView key="event_emergency" name="event_emergency" />
    <RouterView key="notfound" name="notfound" />
    <RouterView key="waiting" name="waiting" />
    <RouterView key="companyCustomer" name="companyCustomer" />
    <RouterView key="terms" name="terms" />
    <RouterView key="player" name="player" />
    <RouterView key="connection" name="connection" />
    <RouterView key="partnerConnection" name="partnerConnection" />
    <RouterView key="revocationPromotion" name="revocationPromotion" />
    <EventProcessor />
    <LayerPopupView />
  </div>
</template>

<script>
  import EventProcessor from '@/components/EventProcessor'
  import { logger, sendKnock, setDisableScrolling } from '@/common/utils/common'
  import { setRouteHistory } from '@/common/utils/router.utils'
  import { mapGetters, mapMutations } from 'vuex'
  import LoginPopup from '@/components/member/LoginPopup.vue'
  import LayerPopupView from '@/pages/popup/LayerPopupView'
  import cookie from '@/common/utils/cookie'

  export default {
    components: {
      EventProcessor,
      LayerPopupView,
      LoginPopup,
    },
    computed: {
      ...mapGetters(['loginPopupState']),
    },
    watch: {
      loginPopupState(isOpen) {
        isOpen ? this.showLoginPopupProc() : this.closeLoginPopupProc()
      },
      $route(to) {
        setRouteHistory(to)
        this.$nextTick(() => {
          const goContentsEl = document.getElementById('go-contents')
          goContentsEl && goContentsEl.focus()
        })
      },
    },
    created() {
      sendKnock()
      cookie.setCsIntoStore()
    },
    methods: {
      ...mapMutations(['hideLoginPopup', 'setCsInfo']),
      showLoginPopupProc() {
        this.$events.$emit('setInputShow', false)
        setDisableScrolling(true) // 윈도우 스크롤 방지
        if (window.playerInstance) window.playerInstance.clearEvent() // 플레이어 키 이벤트 비활성화
      },
      closeLoginPopupProc() {
        this.hideLoginPopup()
        setDisableScrolling(false) // 윈도우 스크롤 사용
        if (window.playerInstance) window.playerInstance.setupEvent() // 플레이어 키 이벤트 활성화
      },
    },
  }

  if (process.env.NODE_ENV !== 'production') {
    logger('red')('---------LOCAL DEV MODE---------')
    logger('red')('---------LOCAL DEV MODE---------')
    logger('red')('---------LOCAL DEV MODE---------')
  }
</script>
<style lang="scss" src="@/assets/scss/common.scss" />
